// @flow
import Map from '_common/components/map/components/Map';

export { Map };
export default Map;
